import { createTheme, Theme } from '@mui/material/styles';

/**
 * Create a consistent theme for the application
 * This ensures styling is consistent across development and production environments
 * 
 * Following SOLID principles:
 * - Single Responsibility: This file is only responsible for theme definition
 * - Open/Closed: Theme can be extended without modifying existing code
 * - Liskov Substitution: Theme interface remains consistent
 * - Interface Segregation: Only exposes necessary theme properties
 * - Dependency Inversion: Components depend on theme interface, not implementation
 */
export const theme: Theme = createTheme({
  typography: {
    fontFamily: '"Work Sans", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif',
  },
  palette: {
    primary: {
      main: '#ecbf16',
    },
    secondary: {
      main: '#000000',
    },
    background: {
      default: '#f5f5f5',
      paper: '#ffffff',
    },
    text: {
      primary: '#000000',
      secondary: '#555555',
    },
  },
  components: {
    MuiBottomNavigation: {
      styleOverrides: {
        root: {
          backgroundColor: 'var(--primary-colour)',
          padding: 0,
          gap: 0,
        },
      },
    },
    MuiBottomNavigationAction: {
      styleOverrides: {
        root: {
          color: 'var(--primary-text-colour) !important',
          backgroundColor: 'rgba(0, 0, 0, 0.1)',
          transition: 'all 0.2s ease',
          padding: '6px 12px',
          minWidth: 0,
          maxWidth: 'none',
          flex: 1,
          '& .MuiBottomNavigationAction-label': {
            color: 'var(--primary-text-colour) !important',
            fontSize: '0.75rem',
          },
          '& .MuiSvgIcon-root': {
            color: 'var(--primary-text-colour) !important',
            fontSize: '1.5rem',
          },
          '&.Mui-selected': {
            color: 'var(--primary-text-colour) !important',
            fontWeight: 700,
            backgroundColor: 'rgba(255, 255, 255, 0.4)',
            '& .MuiBottomNavigationAction-label': {
              color: 'var(--primary-text-colour) !important',
              fontWeight: 700,
              fontSize: '0.85rem',
            },
            '& .MuiSvgIcon-root': {
              color: 'var(--primary-text-colour) !important',
              fontSize: '1.75rem',
            },
          },
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: 8,
        },
      },
    },
    // Add more consistent styling overrides for MUI components
    MuiCssBaseline: {
      styleOverrides: {
        // Global styles
        body: {
          margin: 0,
          padding: 0,
          fontFamily:
            '"Work Sans", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif',
          WebkitFontSmoothing: 'antialiased',
          MozOsxFontSmoothing: 'grayscale',
        },
      },
    },
  },
});
